/* eslint-disable no-plusplus */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { Divider } from '@material-ui/core';

import DataTable from '~/components/DataTable';
import LocaleMessage from '~/components/LocaleMessage';
import CounterCard from '~/components/Reports/CounterCard';
import ExportCSVButton from '~/components/Reports/CSVButton';
import ReportDateChart from '~/components/Reports/ReportDateChart';
import ReportHeader from '~/components/Reports/ReportHeader';
import ReportPieChart from '~/components/Reports/ReportPieChart';
import ReportTimeChart from '~/components/Reports/ReportTimeChart';
import Splash from '~/components/Splash/Inside';

import api from '~/services/pluginbot-api';
import GetDateTimeLabel from '~/util/GetDateTimeLabel';
import GetFileName from '~/util/GetFileName';
import GetPeriodDates from '~/util/GetPeriodDates';
import lng_labels from '~/util/LangMessages';

import AppKeyCallbackDetails from './Details';
import { TotalContainer, InfoContainer, TableArea } from './style';

function formatJsonExport(value) {
    if (value == null) return '';
    try {
        return JSON.stringify(value);
    } catch {
        return String(value);
    }
}

function getResultKey(received) {
    if (!received) return 'error';
    if (received.reason === 'request_failed') return 'error';
    const code = received.statusCode;
    if (code >= 200 && code < 300) return 'success';
    return 'error';
}

export default function AppKeyCallbacksReports({
    settings,
    headerSettings,
    requestError,
    counterData,
    language,
    options,
}) {
    const lng_all = lng_labels[language] || {};

    const {
        fromISO,
        untilISO,
        minDate,
        shortcuts,
        handleFromDateChange,
        handleUntilDateChange,
        handlePeriodShortcut,
    } = headerSettings;

    const { active, colors, format, locale, dateOptions, dark_mode } = settings;

    const mountedRef = React.useRef(true);
    const [isLoading, setIsLoading] = useState(true);
    const [rawLogData, setRawLogData] = useState({});
    const [actionLogList, setActionLogList] = useState([]);
    const [groupedData, setGroupedData] = useState({});
    const [singleObjFilter, setSingleObjFilter] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const headers_file = [
        { key: 'created_date', label: 'Date' },
        { key: 'created_time', label: 'Time' },
        { key: 'group', label: 'Group' },
        { key: 'appkey', label: 'API Key' },
        { key: 'application', label: 'Application' },
        { key: 'callback_url', label: 'Callback URL' },
        { key: 'callback_type', label: 'Callback Type' },
        { key: 'status_label', label: 'Status' },
        { key: 'sent_data_export', label: 'Sent Data' },
        { key: 'received_data_export', label: 'Received Data' },
    ];

    const headers_table = [
        {
            id: 'created',
            order_by: 'timestamp',
            label: <LocaleMessage msg="table.headers.date" />,
        },
        {
            id: 'appkey',
            label: 'API Key',
        },
        {
            id: 'application',
            label: <LocaleMessage msg="table.headers.application" />,
        },
        {
            id: 'callback_url',
            label: (
                <LocaleMessage msg="page.reports.appkey_callbacks.label.callback_url" />
            ),
            width: '20%',
        },
        {
            id: 'callback_type',
            label: (
                <LocaleMessage msg="page.reports.appkey_callbacks.label.callback_type" />
            ),
        },
        {
            id: 'status_label',
            label: (
                <LocaleMessage msg="page.reports.appkey_callbacks.label.status" />
            ),
        },
    ];

    function filterRawData(data) {
        const { groups, applications } = counterData;
        const { period, logs } = data;

        const a_groups = {};
        const a_appkeys = {};
        const a_results = {};
        const a_applications = {};
        const a_date = {};
        const a_time = {};

        const appkeys = {};

        const alist = logs.list.map(a => {
            const datetime = GetDateTimeLabel(new Date(a.created), { format });

            const group = groups[a.group_id];
            const application = applications[a.application_id];
            const result_key = getResultKey(a.received_data);
            const result_chart_label =
                lng_all[
                    `page.reports.appkey_callbacks.label.results.${result_key}`
                ] || result_key.toUpperCase();

            const status_label =
                a.received_data && a.received_data.statusCode
                    ? String(a.received_data.statusCode)
                    : result_key.toUpperCase();

            const { appkey_id } = a;

            if (!appkeys[appkey_id]) {
                appkeys[appkey_id] = {
                    id: appkey_id,
                    name: a.appkey,
                };
            }

            a_groups[a.group_id] = a_groups[a.group_id]
                ? a_groups[a.group_id] + 1
                : 1;

            a_applications[a.application_id] = a_applications[a.application_id]
                ? a_applications[a.application_id] + 1
                : 1;

            a_appkeys[appkey_id] = a_appkeys[appkey_id]
                ? a_appkeys[appkey_id] + 1
                : 1;

            a_results[result_key] = a_results[result_key]
                ? {
                      ...a_results[result_key],
                      value: a_results[result_key].value + 1,
                  }
                : {
                      id: result_key,
                      name: result_chart_label,
                      value: 1,
                  };

            a_date[datetime.date] = a_date[datetime.date]
                ? a_date[datetime.date] + 1
                : 1;

            a_time[datetime.hour] = a_time[datetime.hour]
                ? a_time[datetime.hour] + 1
                : 1;

            return {
                ...a,
                group: group ? group.name : '---',
                application: application ? application.name : '---',
                created_date: datetime.date,
                created_time: datetime.time,
                created: datetime.string,
                timestamp: datetime.timestamp,
                status_label,
                sent_data_export: formatJsonExport(a.sent_data),
                received_data_export: formatJsonExport(a.received_data),
            };
        });

        const appkey_grouped = Object.keys(a_appkeys).map(key => {
            const val = a_appkeys[key];
            const obj = appkeys[key];

            return {
                name: obj ? obj.name : '---',
                value: val,
            };
        });

        const application_grouped = Object.keys(a_applications).map(key => {
            const val = a_applications[key];
            const obj = applications[key];

            return {
                name: obj ? obj.name : '---',
                value: val,
            };
        });

        const group_grouped = Object.keys(a_groups).map(g => {
            const val = a_groups[g];
            const obj = groups[g];

            return {
                name: obj ? obj.name : '---',
                value: val,
            };
        });

        const result_grouped = Object.keys(a_results).map(key => {
            return a_results[key] || {};
        });

        const period_dates = GetPeriodDates(period);

        const d_labels = [];
        const date_grouped = [];
        period_dates.forEach(p => {
            const formatted_date = new Date(p).toLocaleDateString(
                format.format,
                dateOptions
            );
            const label_date = new Date(p).toLocaleDateString(format.format, {
                month: '2-digit',
                day: '2-digit',
            });
            d_labels.push(label_date);
            date_grouped.push({
                date: label_date,
                value: a_date[formatted_date] || 0,
            });
        });

        const t_labels = [];
        const time_grouped = [];
        for (let t = 0; t < 24; t++) {
            const label_time = t < 10 ? `0${t}h` : `${t}h`;
            t_labels.push(label_time);
            time_grouped.push({
                hour: label_time,
                value: a_time[t] || 0,
            });
        }

        setGroupedData({
            results: result_grouped,
            applications: application_grouped,
            appkeys: appkey_grouped,
            groups: group_grouped,
            date: date_grouped,
            time: time_grouped,
            d_labels,
            t_labels,
        });

        setActionLogList(alist);
    }

    async function loadData() {
        setIsLoading(true);
        let query_filters = ``;
        if (options && options.application) {
            query_filters += `&application_id=${options.application}`;
        }
        if (options && options.robot) {
            query_filters += `&robot_id=${options.robot}`;
        }
        if (options && options.appkey) {
            query_filters += `&appkey_id=${options.appkey}`;
        }

        await api
            .get(
                `reports/appkey_callbacks?from=${fromISO}&until=${untilISO}${query_filters}`
            )
            .then(response => {
                const { data } = response;
                filterRawData(data);
                setRawLogData(data.logs);
                setSingleObjFilter(data.appkey || null);
                setIsLoading(false);
            })
            .catch(error => requestError(error));
    }

    useEffect(() => {
        if (mountedRef.current) {
            loadData();
        }
    }, [settings, fromISO, untilISO, locale]);

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);

    function CSVButton() {
        return (
            <ExportCSVButton
                data={actionLogList}
                headers={headers_file}
                filename={GetFileName(`REPORT-appkey_callbacks`, 'csv')}
            />
        );
    }

    function buildDateChart(title, data, key = 'value') {
        return (
            <ReportDateChart
                title={title}
                color={colors.dashboard_graphs}
                data={data}
                labels={groupedData.d_labels}
                dataKey={key}
            />
        );
    }

    function buildHourChart(title, data, key = 'value') {
        return (
            <ReportTimeChart
                title={title}
                color={colors.dashboard_cards}
                data={data}
                labels={groupedData.t_labels}
                dataKey={key}
            />
        );
    }

    const show_group_card = active && active.id === '*';
    const def_class = `col-md-4 col-12 mb-5`;

    const pie_charts = [
        ...(show_group_card
            ? [
                  {
                      key: 'groups',
                      title: 'per_group',
                      color: colors.dashboard_graphs,
                      data: groupedData.groups,
                  },
              ]
            : []),
        {
            key: 'appkey',
            title: 'per_appkey',
            color: colors.dashboard_cards,
            data: groupedData.appkeys,
        },
        {
            key: 'applications',
            title: 'per_application',
            color: colors.dashboard_cards,
            data: groupedData.applications,
        },
        {
            key: 'results',
            title: 'per_result',
            color: colors.dashboard_graphs,
            data: groupedData.results,
        },
    ];

    function handleRowClick(event, rowId) {
        const item = actionLogList.find(row => row.id === rowId);
        if (item) setSelectedItem(item);
    }

    function handleReplayed(updated) {
        setActionLogList(prev =>
            prev.map(row =>
                row.id === updated.id
                    ? {
                          ...row,
                          received_data: updated.received_data,
                          status_label: updated.status_label,
                          received_data_export: formatJsonExport(
                              updated.received_data
                          ),
                      }
                    : row
            )
        );
        setSelectedItem(updated);
    }

    return (
        <>
            {selectedItem ? (
                <AppKeyCallbackDetails
                    item={selectedItem}
                    onClose={() => setSelectedItem(null)}
                    onReplayed={handleReplayed}
                    requestError={requestError}
                    dark_mode={dark_mode}
                />
            ) : null}
            <ReportHeader
                date_props={{
                    locale,
                }}
                period={{
                    minDate,
                    fromDate: new Date(fromISO),
                    untilDate: new Date(untilISO),
                }}
                handleFromDateChange={handleFromDateChange}
                handleUntilDateChange={handleUntilDateChange}
                reloadData={() => loadData()}
                exportButton={CSVButton()}
                shortcuts={shortcuts}
                handleShortcutClick={_id => handlePeriodShortcut(_id)}
            />
            <div className="sidecard-body mt-3">
                {isLoading ? (
                    <Splash />
                ) : (
                    <>
                        {singleObjFilter ? (
                            <>
                                <Divider />
                                <TotalContainer className="mt-3">
                                    <div className="mt-3 mb-3">
                                        <p
                                            className="card-title"
                                            style={{
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            {singleObjFilter.name}
                                        </p>
                                    </div>
                                </TotalContainer>
                            </>
                        ) : null}
                        <Divider />
                        <TotalContainer className="mt-3 mb-5">
                            <CounterCard
                                classes="col-md-4 col-12"
                                title={
                                    <LocaleMessage msg="page.reports.appkey_callbacks.label.total" />
                                }
                                value={rawLogData.total || '0'}
                            />
                        </TotalContainer>
                        <Divider />
                        <InfoContainer className="row mt-3 mb-3">
                            {pie_charts.map(c => {
                                const datakey = 'value';
                                return (
                                    <ReportPieChart
                                        key={`${datakey}_${c.key}`}
                                        classes={def_class}
                                        title={
                                            <LocaleMessage
                                                msg={`page.reports.appkey_callbacks.label.${c.title}`}
                                            />
                                        }
                                        color={c.color}
                                        data={c.data}
                                        dataKey={datakey}
                                        customization={{
                                            stroke: dark_mode
                                                ? '#424242'
                                                : '#ddd',
                                        }}
                                    />
                                );
                            })}
                        </InfoContainer>
                        <Divider />
                        <div className="row mt-3 mb-3">
                            {buildDateChart(
                                <LocaleMessage msg="page.reports.appkey_callbacks.label.per_date" />,
                                groupedData.date
                            )}
                            {buildHourChart(
                                <LocaleMessage msg="page.reports.appkey_callbacks.label.per_hour" />,
                                groupedData.time
                            )}
                        </div>
                        <Divider />
                        <InfoContainer className="row mt-3 mb-3">
                            <TableArea className="col-12 mb-3 table-responsive-material">
                                <div className="mt-3 mb-3">
                                    <p className="card-title">
                                        <LocaleMessage msg="page.reports.appkey_callbacks.label.history" />
                                    </p>
                                </div>
                                <DataTable
                                    maxHeight="100%"
                                    headerColumns={headers_table}
                                    data={actionLogList || []}
                                    orderDirection="desc"
                                    orderColumn="timestamp"
                                    hasActions={false}
                                    handleTableRowClick={handleRowClick}
                                    defaultRowsPerPage={25}
                                    sortable
                                />
                            </TableArea>
                        </InfoContainer>
                    </>
                )}
            </div>
        </>
    );
}

AppKeyCallbacksReports.defaultProps = {
    language: '',
};

AppKeyCallbacksReports.propTypes = {
    settings: PropTypes.object.isRequired,
    headerSettings: PropTypes.object.isRequired,
    requestError: PropTypes.func.isRequired,
    counterData: PropTypes.object.isRequired,
    language: PropTypes.string,
};
